import { useRef, useState } from "react";
import RegisterButton from "../../components/Header/RegisterButton/RegisterButton";
import styles from "./register.module.css";
import { registerUser } from "../../Api/Services/Account";
import { RegisterAccountDt } from "../../Models/AccountModel";
import LoadingIcon from "../../components/LoadingIcon/LoadingIcon";

export default function Register() {
  const [emailError, setEmailError] = useState<{status: boolean, text: string}>({status: false, text: "" });
  const [passwordError, setPasswordError] = useState<{status: boolean, text: string}>({status: false, text: "" });
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [registerSuccess, setRegisterSuccess] = useState<{success: boolean, message: string}>({success: false, message: ""});
  const [loading, setLoading] = useState(false);
  const emailRef = useRef<HTMLInputElement>(null);
  const passowrdRef = useRef<HTMLInputElement>(null);
  const confirmPasswordRef = useRef<HTMLInputElement>(null);
  const termsCheckboxRef = useRef<HTMLInputElement>(null);
  const regErrorRef = useRef<HTMLParagraphElement>(null);

  const Submit = () => {
    const email = emailRef.current?.value as string;
    const password = passowrdRef.current?.value as string;
    const termsCheckbox = termsCheckboxRef.current?.checked;
    checkEmail(email);
    checkPassword(password);
    comparePasswords();
    
    if (emailError.status == false && passwordError.status == false && confirmPasswordError == false && termsCheckbox) {
      setLoading(true);
      const userData: RegisterAccountDt = {email: email, password: password, confirmPassword: password, AgreeToTerms: termsCheckbox};
      registerUser(userData).then((data) => {   
        if (data.success) {
          setRegisterSuccess({success: true, message: data.message});
        }else{
          setRegisterSuccess({success: false, message: data.message});
          setTimeout(() => {
            const rect = regErrorRef.current?.getBoundingClientRect();
            const isVisible = rect != undefined && rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            if (!isVisible) {
              regErrorRef.current?.scrollIntoView({behavior: "smooth"});
            }
          }, 100);
        }
        setLoading(false);
      });
    }
  }

  const checkEmail = (email: string) => {
    if (email.trim() == "") {
      setEmailError({status: true, text: "Email is required" });
      return false;
    }else if (!email.includes("@") && !email.includes(".")) {
      setEmailError({status: true, text: "Email is not valid" });
      return false;
    }else{
      setEmailError({status: false, text: "" });
    }
  }

  const checkPassword = (password: string) => {
    if(password.length < 6){
      setPasswordError({status: true, text: "Password must be at least 6 characters long"});
      return false;
    }
    // Check if password contains both letters and numbers
    const hasLetters = /[a-zA-Z]/.test(password);
    const hasNumbers = /[0-9]/.test(password);

    if (hasLetters && hasNumbers) {
      setPasswordError({status: false, text: ""});
    } else {
      setPasswordError({status: true, text: "Password must contain both letters and numbers"});
      return false;
    }
  }

  const comparePasswords = () => {
    if (passowrdRef.current?.value !== confirmPasswordRef.current?.value) {
      setConfirmPasswordError(true);
      return false;
    }else{
      setConfirmPasswordError(false);
      return true;
    }
  }

  return (
    <div className={styles.container}>
      {loading && <LoadingIcon />}
      <h1>Register</h1>
      {registerSuccess.success && ( <p className="success_text">{registerSuccess.message}</p>)}
      {!registerSuccess.success && (
        <>
        <p>
          Boost your digital presence by advertising your safer solutions
          effortlessly through easy-to-upload advertisements and reach new
          customers worldwide with a single global tool.
        </p>
        {registerSuccess.message != "" && <p ref={regErrorRef} className={`${styles.error_message} error_text`}>{"Something went wrong with the reigstration, please try again later"}</p>}
        <form>
        <div className={styles.email}>
          <label htmlFor="email" className={styles.label}>
            Email address
          </label>
          <input
            ref={emailRef}
            type="email"
            id="email"
            name="email"
            autoComplete="email"
            className={`${styles.input} ${emailError.status ? "error" : ""}`}
            placeholder="Your email address"
            onBlur={(e) => checkEmail(e.target.value)}
          />
          {emailError.status && <span className="error_text">{emailError.text}</span>}
        </div>
        <div className={styles.password}>
          <label htmlFor="password" className={styles.label}>
            Password
          </label>
          <span>(Both letters and numbers required, minimum 6 letters long)</span>
          <input
            ref={passowrdRef}
            type="password"
            id="password"
            name="password"
            autoComplete="new-password"
            className={`${styles.input} ${passwordError.status ? "error" : ""}`}
            placeholder="*****"
            onBlur={(e) => checkPassword(e.target.value)}
          />
          {passwordError.status && <span className="error_text">{passwordError.text}</span>}
        </div>
        <div className={styles.password}>
          <label htmlFor="password" className={styles.label}>
            Confirm password
          </label>
          <input
            ref={confirmPasswordRef}
            type="password"
            id="ConfirmPassword"
            name="ConfirmPassword"
            autoComplete="new-password"
            className={`${styles.input} ${confirmPasswordError ? "error" : ""}`}
            placeholder="*****"
            onBlur={() => comparePasswords()}
          />
          {confirmPasswordError && <span className="error_text">Passwords do not match</span>}
        </div>
        <input
          ref={termsCheckboxRef}
          type="checkbox"
          className={styles.checkbox}
          id="termsCheckbox"
          required
        />
        <label className={styles.termsLabel} htmlFor="termsCheckbox">
          I agree to the <a href="terms-conditions">terms and conditions</a> for
          advertising at ChemSec Marketplace
        </label>
        <RegisterButton isRegisterPage={true} HandleOnClick={Submit} />
      </form>
      </>)}
    </div>
  );
}
